import GATSBY_COMPILED_MDX from "/home/jenkins/agent/workspace/site-verticals-deployment_master/packages/clearscore/apps/website/.cache/caches/gatsby-source-filesystem/559b63a06fe464eb5a0531ceb740a2b8/legal-page-9041fb7c-133c-59d3-93a7-740386d1df16.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import Legal from '@clearscore/website.legal';
import Layout from '../components/layout';
const LegalTemplate = ({data, pageContext: {pages, isWebView, localisations = []}, location, children}) => {
  const {childMdx, meta, language: {title}, effectiveFrom, version} = data.legalPages;
  const timeToRead = childMdx?.timeToRead ?? 0;
  const wordCount = childMdx?.wordCount?.words ?? 0;
  const tableOfContents = childMdx?.tableOfContents ?? ({
    items: []
  });
  const remappedPages = pages.map(({href, label}) => ({
    url: href,
    title: label
  }));
  return React.createElement(Layout, {
    meta: meta,
    location: location.pathname,
    localisations: localisations
  }, ({commonModules}) => React.createElement(Legal, {
    isWebView: isWebView,
    pages: remappedPages,
    version: version,
    pageConfig: {
      timeToRead,
      wordCount,
      displayDescription: false,
      ctaUrl: '',
      tableOfContents
    },
    effectiveFrom: effectiveFrom,
    language: {
      title,
      content: children
    },
    appStoreConfig: commonModules.app_store
  }));
};
export const query = graphql`
    query Legal($slug: String, $locale: String, $version: String) {
        legalPages(slug: { eq: $slug }, locale: { eq: $locale }, version: { eq: $version }) {
            childMdx {
                timeToRead
                wordCount {
                    words
                }
                tableOfContents
            }
            version
            effectiveFrom
            language {
                title
            }
            meta {
                title
                description
                url
            }
        }
    }
`;
LegalTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(LegalTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
